export default {
  midas: [
    'FARMACIA PRIVADA',
    'FARMACIA ASISTENCIAL PRIVADA',
    'BOTIQUIN PUBLICO',
    'FARMACIA POPULAR',
    'BOTIQUIN PRIVADO',
    'ALMACÉN FARMACÉUTICO',
    'FARMACIA ASISTENCIAL PUBLICA'
  ],
  medical_center: null
};
